export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; Max-Age=0; path=/; secure`;
};
